<template>
    <div class="loading-status">
        <div v-if="loading" class="loading-loading">
            <i class="el-icon-loading" />
            加载中
        </div>
        <div v-if="complete" class="loading-complate">
            没有更多了
        </div>
    </div>
</template>
<script>
/**
 * @file
 * @author
 */
export default {
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        complete: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="less" scoped>
.loading-status {
    display: block;
    width: 100%;
    margin-top: 40px;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    color: #999999;
    i {
        margin-right: 8px;
    }
}
</style>